import {
    SET_BREADCRUMB_ITEMS
} from './actionTypes';

interface BreadcrumbItem {
  title: string;
  link: string;
}

export const setBreadcrumbItems = (title: string, items: BreadcrumbItem[]) => ({
    type: SET_BREADCRUMB_ITEMS,
    payload: {
        title : title,
        items : items
    }
});